import React, { useEffect, useState } from 'react';
import './NavigationView.css';
import { Divider, Dropdown, Menu, Space } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import blackLogo from '../../../assets/homeImages/home_switch_image/logo.png';
import whiteLogo from '../../../assets/homeImages/home_switch_image/logo-white.png';

const NavigationView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isTransparentHeader, setIsTransparentHeader] = useState(true);

  useEffect(() => {
    const navBg = document.querySelector('#navigation');

    const handleScroll = () => {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      let left =
        document.documentElement.scrollLeft || document.body.scrollLeft;

      if (top > 10 || location.pathname.includes('/about')) {
        setIsTransparentHeader(false);
        navBg.className = 'navigationView_white';
      } else {
        setIsTransparentHeader(true);
        navBg.className = '';
      }

      navBg.style.left = `-${left}px`;
    };

    window.addEventListener('scroll', handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location]);

  const handleMenuClick = (path) => {
    navigate(path);
  };

  const solutionMenu = (
    <Menu
      onClick={(e) => handleMenuClick(e.key)}
      selectedKeys={[location.pathname]}
    >
      <Menu.Item key="/solution/factoring">保理系统</Menu.Item>
      <Menu.Item key="/solution/trade">贸易系统</Menu.Item>
      <Menu.Item key="/solution/supply">供应链金融</Menu.Item>
      <Menu.Item key="/solution/financial/leasing">融资租赁</Menu.Item>
    </Menu>
  );

  const getHighlightClass = (path) => {
    return location.pathname === path ? 'highlight' : '';
  };

  return (
    <div id="navigation">
      <div className="nav-content">
        <img
          onClick={() => navigate(`/home`)}
          className="logo"
          src={isTransparentHeader ? whiteLogo : blackLogo}
          alt=""
        />
        <Space
          size={30}
          split={<Divider type="vertical" />}
          style={isTransparentHeader ? { color: '#fff' } : {}}
        >
          <span
            className={getHighlightClass('/home')}
            onClick={() => handleMenuClick('/home')}
          >
            首页
          </span>
          <span
            className={getHighlightClass('/about')}
            onClick={() => handleMenuClick('/about')}
          >
            关于我们
          </span>
          <Dropdown overlay={solutionMenu}>
            <span
              className={
                location.pathname.startsWith('/solution') ? 'highlight' : ''
              }
            >
              行业解决方案
            </span>
          </Dropdown>
          <span
            className={getHighlightClass('/product/services')}
            onClick={() => handleMenuClick('/product/services')}
          >
            产品服务
          </span>
          <span
            className={getHighlightClass('/qualification/certificate')}
            onClick={() => handleMenuClick('/qualification/certificate')}
          >
            新闻中心
          </span>
          <span
            className={getHighlightClass('/partners')}
            onClick={() => handleMenuClick('/partners')}
          >
            合作伙伴
          </span>
          <span
            className={getHighlightClass('/contact')}
            onClick={() => handleMenuClick('/contact')}
          >
            联系我们
          </span>
          <span
            className={getHighlightClass('/trial')}
            onClick={() => handleMenuClick('/trial')}
          >
            申请试用
          </span>
        </Space>
      </div>
    </div>
  );
};

export default NavigationView;
